import { render, staticRenderFns } from "./peopleMail.vue?vue&type=template&id=88f3f270&scoped=true&"
import script from "./peopleMail.vue?vue&type=script&lang=js&"
export * from "./peopleMail.vue?vue&type=script&lang=js&"
import style0 from "./peopleMail.vue?vue&type=style&index=0&id=88f3f270&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "88f3f270",
  null
  
)

export default component.exports